// removed by extract-text-webpack-plugin
module.exports = {"button":"_2NPp5jhecP0sqhDyaULUTA","new-button":"_2J3l3-m_mJmDvHnMsnOeBE","show-cms-events-toggle":"_2vb-AacnC6n7x9-Vbx5u7m"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/buttons/styles/styles.scss
// module id = 395
// module chunks = 1